export default '/static/frontend/ReachDigital/12gobiking/dist/assets/dhl-635db512.svg'